import(/* webpackMode: "eager" */ "/vercel/path0/src/app/support/page.tsx");
